<template>
  <v-card
    style="margin:auto;margin-top:50px;height:480px;"
    max-width="1000"
  >
   <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
   <v-card-title style="background-color:#006699;color:white;font-size:16px;">Informação sobre a sua Licença de utilização</v-card-title>
    <v-card-text style="margin-top:30px;margin-left:150px;">
        <v-row>
            <v-col cols="12" md="3">
               <label style="font-size:16px;font-weight:bold;">Plano: </label>
            </v-col>
            <v-col cols="12" md="6">
               <label style="font-size:16px;"><v-chip color="primary">{{(plano_obj !== null)?plano_obj.plano:''}} </v-chip></label>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3">
               <label style="font-size:16px;font-weight:bold;">Estado actual: </label>
            </v-col>
            <v-col cols="12" md="6">
               <label style="font-size:16px;color:green;font-weight:bold">{{(plano_obj !== null)?'Activo':'Sem plano activo'}} </label>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3">
               <label style="font-size:16px;font-weight:bold;">Data de activação: </label>
            </v-col>
            <v-col cols="12" md="6">
               <label style="font-size:16px;">{{(plano_obj !== null)?plano_obj.data_activacao:''}}</label>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3">
               <label style="font-size:16px;font-weight:bold;">Data actual: </label>
            </v-col>
            <v-col cols="12" md="6">
               <label style="font-size:16px;">{{(plano_obj !== null)?plano_obj.data_actual:''}}</label>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3">
               <label style="font-size:16px;font-weight:bold;">Data de expiração: </label>
            </v-col>
            <v-col cols="12" md="6">
               <label style="font-size:16px;">{{(plano_obj !== null)?plano_obj.data_expiracao:''}} </label>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3">
               <label style="font-size:16px;font-weight:bold;">Dias restantes:</label>
            </v-col>
            <v-col cols="12" md="6">
               <label  v-if="utilitario.ObterNumeroDeDias(plano_obj.data_actual,plano_obj.data_expiracao) >= 20" :style="(utilitario.ObterNumeroDeDias(plano_obj.data_actual,plano_obj.data_expiracao) >=20)?'font-size:16px;color:green;font-weight:bold':'font-size:16px;color:orange;font-weight:bold'">{{(plano_obj !== null)?utilitario.ObterNumeroDeDias(plano_obj.data_actual,plano_obj.data_expiracao):''}} </label>
               <label v-if="utilitario.ObterNumeroDeDias(plano_obj.data_actual,plano_obj.data_expiracao) <= 5" style="font-size:16px;color:red;font-weight:bold">{{(plano_obj !== null)?utilitario.ObterNumeroDeDias(plano_obj.data_actual,plano_obj.data_expiracao):''}} </label>
            </v-col>
        </v-row>
        <small>* Evite o corte de acesso ao sistema regularizando a situação da sua licença de utilização junto aos nossos canais de comunição.</small>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer> <!-- v-if="utilitario.ObterNumeroDeDias(plano_obj.data_activacao,plano_obj.data_expiracao) <= 15" -->
        <v-btn  @click="renovarPlano()" color="green" style="color:white;">Renovar licença</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import axios from '../../plugins/axios'
import utilitario from '../../plugins/utilitarios'
const ls = require('local-storage')
export default {
     
     data: () =>({
        overlay: true,
        plano_obj: null,
        utilitario:utilitario,
     }),

     created(){
        this.ObterPlanoActivo ()
     },

     computed: {

        getMacAdress(){
         return ls.get('macadress')
      }

     },

     methods:{

          async ObterPlanoActivo (){
                let params = 
                {
                  mac:this.getMacAdress,
                  empresa_id: ls.get('i_id')
               }
                try {
                   let result = await axios.post('/Obter-plano-activo',params)
                   console.log(result);
                   if(result.data.length >= 1){
                      this.plano_obj = result.data[0]
                   }else{

                   }
                } catch (error) {
                  this.overlay = false  
                }finally{
                   this.overlay = false
                }
                

           },

           renovarPlano (){
              this.$store.state.plano_obj = this.plano_obj
              this.$router.push('renovar-licenca')
           }

     }

}
</script>